import { defineComponent as _defineComponent } from 'vue'


export type ActionType = {
  text: string
  handler: (item: any) => any
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuDropdown',
  props: {
    actions: null,
    item: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})